// extracted by mini-css-extract-plugin
module.exports = {"err":"Error_err__2b0B6"};